<template>
  <div class="page-footer">
    <div class="page-footer-height">
      <slot />
    </div>
  </div>
</template>